import Vue from 'vue'
import ActionCableVue from 'actioncable-vue'

if (process.client) {
  Vue.use(ActionCableVue, {
    debug: process.env.NODE_ENV === 'development',
    debugLevel: 'all',
    connectionUrl: process.env.WEBSOCKET_URL,
    connectImmediately: false,
  })
}
